var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar"},[_c('NavbarTitle'),_c('div',{staticClass:"navbar-desc"},[_c('NavbarLinks'),_c('NavbarRoadmap')],1),(_vm.menu)?_c('div',{staticClass:"navbar-res"},[_c('NavbarLinks'),_c('NavbarRoadmap')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }